import React, { useImperativeHandle, forwardRef } from 'react'
import { Form, Input, Button, Row, Col, DatePicker, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

interface QueryFormProps {
  domainOptions?: any[]
  onQuery?: (value: any) => void
}

const QueryForm = (
  { onQuery, domainOptions = [] }: QueryFormProps,
  ref: any
) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { RangePicker } = DatePicker
  const onFinish = (values: any) => {
    if (values.publishTime) {
      values.publishTimeStart = dayjs(values.publishTime[0]).format(
        'YYYY-MM-DD 00:00:00'
      )
      values.publishTimeEnd = dayjs(values.publishTime[1]).format(
        'YYYY-MM-DD 23:59:59'
      )
      delete values.publishTime
    }
    if (values.createTime) {
      values.createTimeStart = dayjs(values.createTime[0]).format(
        'YYYY-MM-DD 00:00:00'
      )
      values.createTimeEnd = dayjs(values.createTime[1]).format(
        'YYYY-MM-DD 23:59:59'
      )
      delete values.createTime
    }
    typeof onQuery === 'function' && onQuery(values)
  }
  const onReset = () => {
    form.resetFields()
    typeof onQuery === 'function' && onQuery({})
  }

  useImperativeHandle(ref, () => {
    return {
      resetQuery: onReset,
    }
  })
  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onFinish}
      labelCol={{
        span: 6,
      }}
      labelAlign="left"
      autoComplete="off"
    >
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Form.Item name="dictType" label={t('dict.dictType')}>
            <Select
              placeholder={t('ikg.select', { name: t('dict.dictType') })}
              options={domainOptions}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="dictName" label={t('dict.name')}>
            <Input placeholder={t('ikg.input', { name: t('dict.name') })} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="exportBy" label={t('dict.operator')}>
            <Input placeholder={t('ikg.input', { name: t('dict.operator') })} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="publishTime" label={t('dict.publishTime')}>
            <RangePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="createTime" label={t('dict.createTime')}>
            <RangePicker style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              gap: 16,
            }}
          >
            <Button onClick={onReset}>{t('ikg.reset')}</Button>
            <Button type="primary" onClick={() => form.submit()} ghost>
              {t('ikg.query')}
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default forwardRef(QueryForm)
